import React, { useMemo } from "react";
import App from "./App";
import { Provider } from "react-redux";
import Spinner from "./spinners/spinner";

import Notistack from "./common/notistack";
import ThemeProvider from '../../theme'

const Root = ({ store }) => {
  return (
    <Provider store={store}>
      <Notistack>
          <ThemeProvider>
            <App />
            <Spinner />
          </ThemeProvider>
      </Notistack>
    </Provider>
  );
};

export default Root;
